"use client";

import { useState } from "react";
import { toast } from "react-hot-toast";
import Modal from "../../../components/shared-modules/Modal";
import styles from "../../../styles/statusModal.module.css";
import { updateStatus } from "../../../services/admin/statuses";
import { handleApiError } from "../../../utils/handleApiError";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import Button from "../../../components/button-v1";
import { useQueryClient } from "@tanstack/react-query";

const EditStatusModal = ({
  isOpen,
  onClose,
  status_info,
  comp_renderer,
  current_render,
}) => {
  const queryClient = useQueryClient();
  const [name, setName] = useState(status_info?.name || "");
  const [description, setDescription] = useState(
    status_info?.description || ""
  );
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await updateStatus(status_info.id, {
        name,
        description,
      });
      // comp_renderer(!current_render);
      toast.success("Status updated successfully");
      queryClient.invalidateQueries(["admin-statuses"]);
      onClose();
      setLoading(false);
    } catch (error) {
      handleApiError(error);
      setLoading(false);
    }
  };

  const modalFooter = (
    <div className={styles.modal_footer}>
      <button
        type="button"
        className={styles.cancel_btn}
        onClick={onClose}
        disabled={loading}
      >
        Cancel
      </button>
      <button
        type="submit"
        form="editStatusForm"
        className={styles.submit_btn}
        disabled={loading || !name.trim()}
      >
        {loading ? "Updating..." : "Update Status"}
      </button>
    </div>
  );

  return (
    <Dialog open={isOpen} setOpen={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Status</DialogTitle>
        </DialogHeader>
        <DialogBody>
          {" "}
          <form
            id="editStatusForm"
            onSubmit={handleSubmit}
            className={styles.form}
          >
            <div className={styles.form_group}>
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className={styles.input}
              />
            </div>
            <div className={styles.form_group}>
              <label htmlFor="description">Description (Optional)</label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className={styles.textarea}
                rows={4}
                placeholder="Enter status description (optional)"
              />
            </div>
          </form>
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} loading={loading}>
            Update
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EditStatusModal;
